<template>
  <div
    id="third-container-column"
    ref="columnRoot"
    v-editable
    class="flex h-auto flex-wrap justify-start gap-5"
    style="padding-right: 1.5rem"
  >
    <div
      v-for="(clickableImage, index) in clickableImages"
      :key="clickableImage._uid"
    >
      <InteractableImage
        class="w-48 [@media(min-width:1520px)]:w-56 [@media(min-width:1680px)]:w-64 [@media(min-width:1800px)]:w-72"
        :blok="clickableImage"
        promotion-name="flyout_teaser"
        :is-full-width="false"
        :sibling-index="index"
        @click="onClick(clickableImage, $event)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import InteractableImage from '~/storyblok/media/InteractableImage.vue'
import useUiState from '~/composables/ui/useUiState'
import useTrackingEvents from '~/composables/tracking/useTrackingEvents'
import type { SbInteractableImage } from '~/cms/storyblok/types/storyblok.d.ts'

defineProps<{
  clickableImages: SbInteractableImage[]
  hasNoChildrenAtAll: boolean
}>()

const emit = defineEmits<{
  (e: 'register-column', el: HTMLElement | null): void
}>()
const { trackNavigationFlyout } = useTrackingEvents()
const { closeFlyoutMenu } = useUiState()
const columnRoot = ref<HTMLElement | null>(null)

onMounted(() => {
  emit('register-column', columnRoot.value)
})

const onClick = (image: SbInteractableImage, event: MouseEvent) => {
  const navigationPoint =
    image.creative_name ||
    image.CtaButton?.[0]?.ctaLabel ||
    image.Image?.[0]?.altDescription

  if (navigationPoint) {
    trackNavigationFlyout(navigationPoint, 2)
  }

  closeFlyoutMenu(event, true)
}

onMounted(() => {
  emit('register-column', columnRoot.value)
})
</script>
